import type { DateDisplayType, DateFormat, DateRangeFormatOption, EventDateDisplayContent } from './eventDateDisplay.types';

// Maps the event-level date config (EventInfo.dateMetadata + endDate) into the EventDateDisplayContent subset
// that `resolveEventDateDisplay` reads, so every surface can render event-level data through the same path it
// uses for the legacy welcome-page JSON blob (PRNT-4548). Pure: type-only imports, no runtime deps.

type EventDateMetadataInput =
  | Readonly<{
      customText?: string | null;
      dateDisplayType?: string | null;
      dateFormat?: string | null;
      dateRangeFormat?: string | null;
    }>
  | null
  | undefined;

export const eventDateMetadataToContent = (
  dateMetadata: EventDateMetadataInput,
  // The range END as an ISO-8601 timestamp (EventInfo.endDate.timestamp). Timezone is applied downstream
  // by resolveEventDateDisplay (via the timezone option), so a UTC instant is correct here.
  endDateTimestamp: string | null | undefined,
): EventDateDisplayContent => ({
  dateFormat: (dateMetadata?.dateFormat as DateFormat) ?? undefined,
  dateDisplayType: (dateMetadata?.dateDisplayType as DateDisplayType) ?? undefined,
  dateRangeFormat: (dateMetadata?.dateRangeFormat as DateRangeFormatOption) ?? undefined,
  customText: dateMetadata?.customText ?? undefined,
  eventEndDate: endDateTimestamp ?? undefined,
});
